import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import PromotionBanner from "elements/PromotionBanner";
import Flickity from "react-flickity-component";
import DOMPurify from "dompurify";
import api from "services/api";
import { __ } from "services/Translator";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import Slider from "react-slick";

// components
import Faqs from "../elements/Faqs";
import BottomBanner from "../elements/BottomBanner";
import Banner from "../elements/Banner";

export default function WelcomePromotions(props) {
  // const __ = (text) => text;

  // BONUS
  const prevBonus = () => {
    bonusRef.current.slickPrev();
  };
  const nextBonus = () => {
    bonusRef.current.slickNext();
  };

  const bonusSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const bonusRef = useRef();

  //

  const flkty = useRef(null);

  const nextLoad = () => {
    flkty.current.next();
  };

  const prevLoad = () => {
    flkty.current.previous();
  };

  const isAuthenticated = props.isAuthenticated;
  const [pageContent, setPageContent] = useState({});
  const [promotions, setPromotions] = useState([]);

  const getResults = async () => {
    var response = await api.get("/promotions");

    if (response.status === 200) {
      setPageContent(response.data.content_data);
      setPromotions(response.data.promotions);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  const toggleExpanded = (index) => {
    var promotionsClone = JSON.parse(JSON.stringify(promotions));
    promotionsClone[index].expanded = !promotionsClone[index].expanded;
    setPromotions(promotionsClone);
  };

  useEffect(() => {
    getResults();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {__(
            "Joker Casino | Get Bonuses on your first 2 Deposits, see what else is available here!"
          )}
        </title>
        <meta
          name="description"
          content={__(
            "Joker Casino! See all the latest fun Promotions we run which give you extra play for your buck - Check back regularly for all the latest news!"
          )}
        />
      </Helmet>

      <div className="promotions_page">
        <Banner
          pageName="promotions"
          selectedMenu="welcome-promotions"
          {...props}
        />
        <section className="game_section">
          <div className="container">
            {/* <div className="section_title margin_top_15">
              {__("Our Selection")}
            </div>
            <div className="paragraph text-center">
              {__(
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod"
              )}
            </div>
            <div className="paragraph text-center margin_bottom_15">
              {__("tempor, Lorem ipsum dolor .")}
            </div>

            <div className="section_headline margin_top_15 margin_bottom_30">
              <div className="headline_text">
                {__("Promotions of the Week")}
              </div>
            </div> */}

            <div className="promotions_slider">
              <Slider ref={bonusRef} {...bonusSettings}>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          {props.isAuthenticated ? (
                            <Link
                              to="/games/slots"
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Play Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          ) : (
                            <Link
                              onClick={() => {
                                props.setModalSignUpPropsData(true);
                              }}
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Sign Up Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          )}

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          {props.isAuthenticated ? (
                            <Link
                              to="/games/slots"
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Play Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          ) : (
                            <Link
                              onClick={() => {
                                props.setModalSignUpPropsData(true);
                              }}
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Sign Up Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          )}

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          {props.isAuthenticated ? (
                            <Link
                              to="/games/slots"
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Play Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          ) : (
                            <Link
                              onClick={() => {
                                props.setModalSignUpPropsData(true);
                              }}
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Sign Up Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          )}

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          {props.isAuthenticated ? (
                            <Link
                              to="/games/slots"
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Play Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          ) : (
                            <Link
                              onClick={() => {
                                props.setModalSignUpPropsData(true);
                              }}
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Sign Up Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          )}

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          {props.isAuthenticated ? (
                            <Link
                              to="/games/slots"
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Play Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          ) : (
                            <Link
                              onClick={() => {
                                props.setModalSignUpPropsData(true);
                              }}
                              className={
                                "angle_btn margin_top_15  border_white " +
                                props.landingType
                              }
                            >
                              {__("Sign Up Now")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="red"
                                class="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                />
                              </svg>
                            </Link>
                          )}

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
            <br />
            <br />
            <div className="slider_prev_next ">
              <button onClick={prevBonus} className="action_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="20"
                  fill="white"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                  />
                </svg>
                Prev
              </button>
              <button onClick={nextBonus} className="action_btn">
                Next
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="20"
                  fill="white"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </section>
        <BottomBanner {...props} />
        <Faqs {...props} />
      </div>

      {/* <PromotionBanner pageName="promotion" {...props} /> */}
      <div className="promotions d-none">
        <div className="container">
          <div className="promotion_list">
            {promotions
              .filter((item) => item.priority === 1)
              .map((promotion, index) => (
                <div className="single_promotion" key={index}>
                  <div className="propotion_left">
                    <div className="promotion_headline">
                      {promotion.subtitle}
                    </div>
                    <div
                      className="paragraph white"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(promotion.details),
                      }}
                    ></div>

                    {props.isAuthenticated ? (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          props.setOpenWalletModalTab("deposit");
                        }}
                        className="common_btn no_margin"
                        to="#"

                      >
                        {__("Sign Up Now!")}
                      </Link>
                    ) : (
                      <Link
                        className="common_btn no_margin margin_bottom_15"
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          setTimeout(function () {
                            props.setModalSignUpPropsData(false);
                          }, 500);
                        }}
                      >
                        {__("Sign Up Now!")}
                      </Link>
                    )}
                  </div>

                  <div className="promotion_right">
                    <div className="coins">
                      <div className="dashed"></div>
                      <div className="coin_image">
                        <img src={promotion.image} />
                      </div>
                    </div>

                    <div className="text_area">
                      <div className="terms_btn">
                        <Link
                          className="common_btn small no_margin"
                          to="/bonus-terms"
                        >
                          {__("terms")}
                        </Link>
                      </div>
                      <div className="clearfix"></div>

                      <div className="text_heading">{promotion.title}</div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="promotion_bottom_area d-none">
          <div className="container position_relative">
            <div className="promotion_slider">
              <div className="category_games_header">
                <div className="headline_left">
                  <h4 className="game_headline">{__("Other Promotions")}</h4>
                </div>
                <div className="slider_controlls">
                  <button onClick={prevLoad} className="prev">
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <button onClick={nextLoad} className="prev next">
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
              <Flickity
                flickityRef={(carouselRef) => {
                  flkty.current = carouselRef;
                }}
                options={{
                  groupCells: true,
                  cellAlign: "left",
                  prevNextButtons: false,
                  pageDots: false,
                }}
                reloadOnUpdate
                className="custom_slider"
              >
                {promotions
                  .filter((item) => item.priority === 2)
                  .map((promotion, index) => (
                    <div className="promotion_slide" key={index}>
                      <div className="promotion_image">
                        <img src={promotion.image} />
                      </div>
                      <div className="promiton_detadils">
                        <div className="text">{promotion.title}</div>
                        <div className="icon">
                          <Link to="#">
                            <i className="fas fa-chevron-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
              </Flickity>
            </div>

            <div className="promotion_bottom_banner margin_top_15">
              <img
                className="banner_bottom_bg d-none d-md-block"
                src={
                  require("assets/images/banners/promotion-bottom.png").default
                }
              />
              <img
                className="banner_bottom_bg d-block d-md-none"
                src={
                  require("assets/images/banners/promotion-bottom-mobile.png")
                    .default
                }
              />
              <div className="banner_text_section">
                <div className="banner_heading">
                  {__("Free VIP Weekly Bonuses Cash, Spins & more.")}
                </div>
                <div className="banner_dashed"></div>
                <div className="paragraph white text-center no_margin">
                  {__(
                    "Enjoy BIG bonuses, VIP goodies and awards that the 'regular brick' casinos give to their valued VIPs? Joker Casino has got this and more for all our platinum and diamond VIPs"
                  )}
                  !
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
